export class SocialShare {


	public constructor() {
		let shareButtons = document.querySelectorAll('.social-share-btn');
		let shareButtonWrapper = document.querySelector('.share-button-wrapper') as HTMLElement;
		let shareButtonOpen = document.querySelector('.share-toggle.toggle-open') as HTMLElement;
		let shareButtonClose = document.querySelector('.share-toggle.toggle-close') as HTMLElement;

		var defaultOptions: ISocialShareOptions = {
			type: 'email',         // default share type
			url: '',               // url to share
			title: document.title, // title to share
			image: '',             // image to share
			text: '',              // text to share
			utm_source: '',
			utm_medium: '',
			utm_campaign: '',
			popup_width: 626,
			popup_height: 450,
			link_telegram: 'https://telegram.me/share/url',
			link_whatsapp: 'https://wa.me/'
		};
		
		shareButtons.forEach((button: HTMLAnchorElement) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();

				if (button.classList.contains('share-toggle')) {
					if (button.classList.contains('toggle-open')) {
						shareButtonWrapper.fadeIn();
						shareButtonClose.classList.remove('d-none');
						shareButtonOpen.classList.add('d-none');
					} else {
						shareButtonWrapper.fadeOut();
						shareButtonClose.classList.add('d-none');
						shareButtonOpen.classList.remove('d-none');
					}

					return false;
				}

				var withoutPopup = [
					'telegram',
					'whatsapp',
					'email'

				];
				var tryLocation = true; 
				var link: string;

				let options = this.extend(
					this.getData(button as HTMLElement, defaultOptions),
						defaultOptions
					
				);

				let social = new SocialShareHelper();
				switch (options.type) {
				case 'facebook':
					link = social.facebook(options);
					break;
				case 'twitter':
						link = social.twitter(options);
						break;
					case 'email':
						link = social.email(options);
						break;
					case 'linkedin':
						link = social.linkedin(options);
					break;
				default:
					link = social.unknown(options);
				}
			


				if (withoutPopup.indexOf(options.type) === -1) { 
					tryLocation = this.popup(link, options) === null;
				}
				
				if (tryLocation) {                      
					if (button.tagName === 'A') {       
						button.setAttribute('href', link); 
						if (options.type == 'email') {
							location.href = link;
						}						
						return true;                        
					} else {
						location.href = link;               
						return false;
					}
				} else {
					return false;
				}
			});
		
		});
	}

	private popup(url: string, _options: ISocialShareOptions) {
		return window.open(url, '', 'toolbar=0,status=0,scrollbars=1,width=' + _options.popup_width + ',height=' + _options.popup_height);
	}

	private extend(setOptions: ISocialShareOptions, defaultOptions:ISocialShareOptions) {
		let out: any = defaultOptions;
		for (var key in setOptions) {
			console.log(key);
			if (setOptions.hasOwnProperty(key)) {
				out[key] = (setOptions as any)[key];
			} 
		}
		return out;
	}

	private getData(el: HTMLElement, defaultOptions: ISocialShareOptions) {
		
			var data: any = {};
			for (var key in defaultOptions) {
				if (defaultOptions.hasOwnProperty(key)) {
					var value = el.getAttribute('data-' + key);
					if (value !== null && typeof value != 'undefined') {
						data[key] = value;
					}
				}
			}
			return data;
		
	}

	
}


export class SocialShareHelper {
	// default handler
	unknown(options: ISocialShareOptions) {
		return encodeURIComponent(this.getUrl(options));
	}

	facebook(options: ISocialShareOptions) {
		return 'https://www.facebook.com/sharer.php'
			+ '?u=' + encodeURIComponent(this.getUrl(options));
	}

	// linkedin
	linkedin(options: ISocialShareOptions) {
		return 'https://www.linkedin.com/shareArticle'
			+ '?mini=true'
			+ '&url=' + encodeURIComponent(this.getUrl(options))
			+ '&title=' + encodeURIComponent(options.title)
			+ '&summary=' + encodeURIComponent(options.text);
	}

	// Twitter
	twitter(options: ISocialShareOptions) {
		var url = this.getUrl(options);
		return 'http://twitter.com/share'
			+ '?text=' + encodeURIComponent(options.title)
			+ '&url=' + encodeURIComponent(url)
			+ '&counturl=' + encodeURIComponent(url);
	}

	// Telegram
	telegram(options: ISocialShareOptions) {
		return options.link_telegram
			+ '?url=' + encodeURIComponent(this.getUrl(options) + "\n" + options.title);
	}

	// WhatsApp
	whatsapp(options: ISocialShareOptions) {
		return options.link_whatsapp
			+ '?text=' + encodeURIComponent(this.getUrl(options) + "\n" + options.title);
	}


	// E-mail
	email(options: ISocialShareOptions) {
		return 'mailto:'
			+ '?subject=' + encodeURIComponent(options.title)
			+ '&body=' + encodeURIComponent(this.getUrl(options))
			+ encodeURIComponent("\n" + options.text);
	}


	public getUrl(options: ISocialShareOptions) {
		if (!options.url) {
			options.url = location.href;
		}
		var url = options.url;
		var utm = '';
		if (options.utm_source) {
			utm += '&utm_source=' + options.utm_source;
		}
		if (options.utm_medium) {
			utm += '&utm_medium=' + options.utm_medium;
		}
		if (options.utm_campaign) {
			utm += '&utm_campaign=' + options.utm_campaign;
		}
		if (utm) {
			url = url + '?' + utm;
		}
		return url;
	}

};


export interface ISocialShareOptions {
	
	type: string,
	url: string,
	title: string,
	image: string,
	text: string,
	utm_source: string,
	utm_medium: string,
	utm_campaign: string,
	popup_width: number,
	popup_height: number,
	link_telegram: string,
	link_whatsapp: string,

}